import {Stack, Typography} from '@mui/material';
import React from 'react';

import {AccordionData} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {HolderDataCollapseProps} from './types';

const finishedLabels =
	translations['pt-br'].privateFlow.refund.previewServiceType.finished;

export function HolderDataCollapse({holderData}: HolderDataCollapseProps) {
	return (
		<AccordionData
			title={finishedLabels.holderDataTitle}
			subtitle={holderData[0]?.content != null ? holderData[0].content : ''}>
			<>
				{holderData.slice(1).map(({labelKey, content}) => (
					<Stack key={labelKey} gap={0.5}>
						<Typography
							variant="body2"
							color="text.secondary"
							fontWeight={600}>
							{finishedLabels[labelKey]}
						</Typography>
						<Typography variant="body1" color="text.primary">
							{content}
						</Typography>
					</Stack>
				))}
			</>
		</AccordionData>
	);
}
